import { render, staticRenderFns } from "./AgreementNfseFields.vue?vue&type=template&id=b0ca8a4e"
import script from "./AgreementNfseFields.vue?vue&type=script&lang=js"
export * from "./AgreementNfseFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports